<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/organizations' }">恐怖组织信息库</el-breadcrumb-item>
            <el-breadcrumb-item>{{countryTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <el-form ref="formData" :model="formData" label-width="130px">

            <el-form-item label="恐怖组织名称">
              <el-input v-model="formData.terrorist_name" placeholder="请输入恐怖组织名称" style="width: 240px;"></el-input>
            </el-form-item>

            <el-form-item label="启用/禁用">
              <el-switch
                v-model="formData.status"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>

            <el-form-item label="恐怖组织介绍">
              <quill-editor v-model="formData.intro"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption" @ready="onEditorReady($event)">
              </quill-editor>
            </el-form-item>


            <el-form-item label="旗帜">
              <img v-if="formData.flag" :src="formData.flag" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.flag"
                ref="nationalFlag"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData"
                :imageUrl="imageUrl"
                :fileList="fileList1"
              ></uploadFlie>
              <el-button v-if="formData.flag" type="primary" @click="formData.flag='' ">编辑</el-button>
            </el-form-item>
            
            <el-form-item label="恐怖组织活动范围">
              <el-select
                placeholder="活动地区（国家）"
                v-model="terroristData.area_id"
                filterable
                clearable
              >
                <el-option
                  v-for="item in addressSelectData"
                  :key="item.id"
                  :label="item.full_area_name"
                  :value="item.id"
                ></el-option>
              </el-select>

              <el-select
                placeholder="对华风险"
                v-model="terroristData.chinese_risk_level"
                filterable
                clearable
                style="margin-left: 20px; width: 120px"
              >
                <el-option
                  v-for="(item,index) in riskLevel"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>

              <el-select
                placeholder="活跃程度"
                v-model="terroristData.active_level"
                filterable
                clearable
                style="margin-left: 20px; width: 120px"
              >
                <el-option
                  v-for="(item,index) in riskLevel"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>

              <el-select
                placeholder="活跃趋势"
                v-model="terroristData.active_trend"
                filterable
                clearable
                style="margin-left: 20px; width: 120px"
              >
                <el-option
                  v-for="(item,index) in trendArr"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>

              <el-input v-model="terroristData.active_range_descr" placeholder="活动范围（100字以内）" style="margin-left: 20px;width: 260px;"></el-input>

              <el-button type="primary" style="margin-left: 20px;" @click="terroristFn">添加</el-button>

            </el-form-item>

            <el-form-item v-for="(item,index) in terroristList" :key="index">
              <el-row :gutter="20">
                <el-col :span="6">
                  {{item.area_name}}
                </el-col>
                <el-col :span="3">
                  {{item.chinese_risk_level}}
                </el-col>
                <el-col :span="3">
                  {{item.active_level}}
                </el-col>
                <el-col :span="3">
                  {{item.active_trend}}
                </el-col>
                <el-col :span="4">
                  {{item.active_range_descr}}
                </el-col>
                <el-col :span="4" class="terror">
                  <span @click="addchildFn(item.area_id)">添加下级地区</span>
                  <span style="margin-left: 10px;" @click="terroristAreaDelFn(item.id)">删除</span>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-for="(items,index) in item.province" :key="index+200">
                <el-col :span="6">
                  |_ {{items.area_name}}
                </el-col>
                <el-col :span="3">
                  {{items.chinese_risk_level}}
                </el-col>
                <el-col :span="3">
                  {{items.active_level}}
                </el-col>
                <el-col :span="3">
                  {{items.active_trend}}
                </el-col>
                <el-col :span="4">
                  <span v-if="items.active_range_descr">{{items.active_range_descr}}</span>
                  <span v-else>--</span>
                </el-col>
                <el-col :span="4" class="terror">
                  <span style="margin-left: 10px;" @click="terroristAreaDelFn(items.id)">删除</span>
                </el-col>
              </el-row>
            </el-form-item>

             <el-form-item v-if="childTurn">
              <el-select
                placeholder="活动地区（地区）"
                v-model="terroristChildData.area_id"
                filterable
                clearable
              >
                <el-option
                  v-for="item in addressSelectChildData"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>

              <el-select
                placeholder="对华风险"
                v-model="terroristChildData.chinese_risk_level"
                filterable
                clearable
                style="margin-left: 20px; width: 120px"
              >
                <el-option
                  v-for="(item,index) in riskLevel"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>

              <el-select
                placeholder="活跃程度"
                v-model="terroristChildData.active_level"
                filterable
                clearable
                style="margin-left: 20px; width: 120px"
              >
                <el-option
                  v-for="(item,index) in riskLevel"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>

              <el-select
                placeholder="活跃趋势"
                v-model="terroristChildData.active_trend"
                filterable
                clearable
                style="margin-left: 20px; width: 120px"
              >
                <el-option
                  v-for="(item,index) in trendArr"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>

              <el-input v-model="terroristChildData.active_range_descr" placeholder="请输入恐怖组织名称" style="margin-left: 20px;width: 260px;"></el-input>

              <el-button type="primary" style="margin-left: 20px;" @click="terroristChildFn">添加</el-button>

            </el-form-item>

            <el-form-item style="margin-top: 80px;">
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <!-- <el-button type="primary" v-if="submit" @click="newSubmit">提交并新建</el-button> -->
              <el-button @click="goToCountryBase">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadFlie from "@/components/unloadFile/index";
// import timeZoneSelect from "./time_zone";
import api from "../api";
import tokenService from "@/utils/services/token_service"

export default {
  components: { uploadFlie },
  data() {
    return {
      countryTitle: "新增条目", //标题
      editorOption: {
        placeholder: '请输入正文'
      },
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "terrorist_flag"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      currentFile: null, //当前文件
      addressSelectData: null, //地址控件选择
      addressSelectChildData: null,
      submit: true, //提交状态
      newConstruction: false, //返回状态
      fileList1: [], //文件列表
      ruleForm: {
        dialogImageUrl: "" //预览地址
      },
      riskLevel: [
        { name: '极高' },
        { name: '高' },
        { name: '较高' },
        { name: '中等' },
        { name: '低' }
      ],
      trendArr: [
        { name: '上升' },
        { name: '持平' },
        { name: '下降' }
      ],
      terroristData: {},
      terroristChildData: {},
      terroristList: [],
      formData: {
        //参数
        flag: ''
      },
      tempId: localStorage.getItem('temp_id'),
      childTurn: false,
      terroristId: ''
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  created() {
    this.initCommonData();
    if(this.tempId != null ) {
      this.terroristAreaListFn()
    }

    //如果有countryId 则是修改状态
    if (this.$route.query.countryId) {
      this.infoCommonData()
      // this.formData.area_id = this.$route.query.countryId;
      this.countryTitle = "修改条目";
      this.submit = false;
    }
  },
  methods: {
    // infoCommonData
    infoCommonData() {
      let data = {
        id: this.$route.query.countryId,
      };
      api
        .terroristInfo(data)
        .then(res => {
          this.formData = res.info
          this.terroristAreaInfoFn(this.formData.id)
          this.fileList1.push({ url: this.formData.national_flag})
        })
        .catch(err => {
          this.$message(err);
        });
    },
    initCommonData() {
      // 获取城市列表
      let data = {
        area_type: 2,
        pagesize: 9999
      };
      api
        .adminAreaList(data)
        .then(res => {
          console.log(res)
          this.addressSelectData = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 提交并新建表单
    newSubmit() {
      let data = this.formData;
      if(data.flag == "") {
        data.flag = this.$refs.nationalFlag.UploadImageUrl;
      }
      data.terrorist_area_tmp_id = this.tempId
      // 编辑状态
      if (this.$route.query.countryId) {
        data.id = this.$route.query.countryId; //添加国家id
        api
          .terrorisEdit(data)
          .then(res => {
            if (res.error_code == 0) {

              this.$message({
                message: "修改成功！",
                type: "success"
              });

              this.formData = {};
              this.submit = true;
              if (this.newConstruction) {
                //修改成功 跳转原页面
                this.goToCountryBase();
                this.newConstruction = false;
              }
            }
          })
          .catch(err => {
            this.$message.error(err.error_message);
          });
      } else {
        // 新增参数
        api
          .terroristAdd(data)
          .then(res => {
            if (res.error_code == 0) {

              this.$message({
                message: "新建成功！",
                type: "success"
              });
              
              this.formData = {};
              this.submit = true;
              if (this.newConstruction) {
                this.goToCountryBase();
                this.newConstruction = false;
              }
            }
          })
          .catch(err => {
             this.$message.error(err.error_message);
          });
      }
    },

    terroristFn() {
      if(this.tempId == null) {
        localStorage.setItem("temp_id",Date.parse(new Date()))
        this.tempId = localStorage.getItem('temp_id')
      }
      if(this.$route.query.countryId) {
        this.$set(this.terroristData,'terrorist_id',this.formData.id)
      }else {
        this.$set(this.terroristData,'terrorist_area_tmp_id',this.tempId)
      }
      api
        .terroristAreaAdd(this.terroristData)
        .then(res => {
          if(res.error_code == 0) {
            this.terroristData = {}
            this.terroristAreaListFn()
          }
        })
        .catch(err => {
          this.$message(err);
        });
    },

    terroristChildFn() {
      if(this.$route.query.countryId) {
        this.$set(this.terroristChildData,'terrorist_id',this.formData.id)
      }else {
        this.$set(this.terroristChildData,'terrorist_area_tmp_id',this.tempId)
      }
      api
        .terroristAreaAdd(this.terroristChildData)
        .then(res => {
          if(res.error_code == 0) {
            this.childTurn = false
            this.terroristChildData = {}
            this.terroristAreaListFn()
          }
        })
        .catch(err => {
          this.$message(err);
        });
    },
    
    terroristAreaInfoFn(ids) {
      let data = {
        terrorist_id: ids
      }
       api
        .terroristAreaList(data)
        .then(res => {
          this.terroristList = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    terroristAreaListFn() {
      let data = {
      }
      if(this.$route.query.countryId) {
        this.$set(data,'terrorist_id',this.formData.id)
      }else {
        this.$set(data,'terrorist_area_tmp_id',this.tempId)
      }
       api
        .terroristAreaList(data)
        .then(res => {
          this.terroristList = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    terroristAreaDelFn(ids) {
      let data = {
        terrorist_area_id: ids
      }
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         api.terroristAreaDelete(data)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("删除成功！")
            }
            this.terroristAreaListFn()
          })
          .catch(err => {
            
          });
      }).catch(() => {
      });
    },
    

    addchildFn(ids) {
      this.childTurn = true
      console.log(ids)
      // 获取城市列表
      let data = {
        area_type: 3,
        pagesize: 9999,
        parent_area_id: ids
      };
      api
        .adminAreaList(data)
        .then(res => {
          this.addressSelectChildData = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 提交表单
    onSubmit() {
      this.newConstruction = true;
      this.newSubmit();
    },

    // 取消跳转原页面
    goToCountryBase() {
      this.$router.push({
        name: "organizations"
      });
    }
  }
};
</script>
<style lang="less" scoped>
  .terror {
    span {
      display: inline-block;
      color: #3ae2c4;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>

<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .ql-editor{
      height:200px;
    }
</style>